<!-- エラーメッセージ画面　認証エラー(混線、利用不可）-->
<template>
  <div> 
    <CrlyAtomsCommonTitleBarMain :title="messageItem.title" />
    <section class="crly-o-error-error-msg-user">
      <p class="crly-line-feed crly-o-error-error-msg-user__message">
        {{ messageItem.text }}
      </p>
      <CrlyAtomsCommonBtnLinkMainColor
        :label="messageItem.label"
        :linkName="messageItem.linkName"
        class="--border --btn-lg --btn-outline"
      />
    </section>
  </div>
</template>

<script>
import CrlyAtomsCommonTitleBarMain from "@crly/components/atoms/common/TitleBarMain.vue";
import CrlyAtomsCommonBtnLinkMainColor from "@crly/components/atoms/common/btn/LinkMainColor.vue";
export default {
  name: "CrlyOrganismsErrorMsgUser",
  components: {
    CrlyAtomsCommonTitleBarMain,
    CrlyAtomsCommonBtnLinkMainColor
  },
  data() {
    return {
      messageItem: {
        title: this.$t("errorMsgUser.busy.title"),
        text: this.$t("errorMsgUser.busy.text"),
        label: this.$t("errorMsgUser.busy.topBtn"),
        linkName: "CrlyTop"
      },
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/organisms/error/errorMsgUser.scss";
</style>
